/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { OrganizationApiConfiguration as __Configuration } from '../organization-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultCompanyInfo } from '../models/list-query-result-company-info';
import { CreateCompanyCommand } from '../models/create-company-command';
import { UpdateCompanyCommand } from '../models/update-company-command';
@Injectable({
  providedIn: 'root',
})
class CompanyService extends __BaseService {
  static readonly GetAllPath = '/api/organization/companies';
  static readonly CreateCompanyPath = '/api/organization/companies';
  static readonly GetCompanyForUpdatePath = '/api/organization/companies/{id}/update';
  static readonly UpdateCompanyPath = '/api/organization/companies/{id}/update';
  static readonly DeleteCompanyPath = '/api/organization/companies/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param query undefined
   * @return Success
   */
  GetAllResponse(query?: {}): __Observable<__StrictHttpResponse<ListQueryResultCompanyInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (query != null) __params = __params.set('query', query.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/companies`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultCompanyInfo>;
      })
    );
  }
  /**
   * @param query undefined
   * @return Success
   */
  GetAll(query?: {}): __Observable<ListQueryResultCompanyInfo> {
    return this.GetAllResponse(query).pipe(
      __map(_r => _r.body as ListQueryResultCompanyInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateCompanyResponse(command?: CreateCompanyCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/organization/companies`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateCompany(command?: CreateCompanyCommand): __Observable<null> {
    return this.CreateCompanyResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetCompanyForUpdateResponse(id: string): __Observable<__StrictHttpResponse<UpdateCompanyCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/companies/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateCompanyCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetCompanyForUpdate(id: string): __Observable<UpdateCompanyCommand> {
    return this.GetCompanyForUpdateResponse(id).pipe(
      __map(_r => _r.body as UpdateCompanyCommand)
    );
  }

  /**
   * @param params The `CompanyService.UpdateCompanyParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateCompanyResponse(params: CompanyService.UpdateCompanyParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/organization/companies/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `CompanyService.UpdateCompanyParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateCompany(params: CompanyService.UpdateCompanyParams): __Observable<null> {
    return this.UpdateCompanyResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteCompanyResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/organization/companies/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteCompany(id: string): __Observable<null> {
    return this.DeleteCompanyResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module CompanyService {

  /**
   * Parameters for UpdateCompany
   */
  export interface UpdateCompanyParams {
    id: string;
    command?: UpdateCompanyCommand;
  }
}

export { CompanyService }
